<template>
  <a :href="link" target="_new" :title="title" class="hidden-sm-and-down" @click="$emit('click')">
    <v-icon small class="mr-1">print</v-icon>
  </a>
</template>

<script>
  export default {
    props: {
      link: {
      	type: String,
      	default: "javascript:void(0);"
      },
      title: {
      	type: String,
      	default: "Print"
      }
    },
  }
</script>
